import { ButtonType, showError, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { useState } from 'react'
import { getAsoAutenticado } from '../../empresa/empresas-list/core/_requests'
import { ArquivoDto } from '../../atendimento/core/_models'
import * as Yup from 'yup'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useFormik } from 'formik'
import { Button, FormInput, LoadingIndicator } from '../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const AutenticacaoPage = () => {
  const { t } = useT()
  const [searchParams] = useSearchParams()
  const code =
    searchParams
      .get('code')
      ?.toUpperCase()
      .match(/.{1,4}/g)
      ?.join('.') || ''

  const [asoAutenticado, setAsoAutenticado] = useState<ArquivoDto>()
  const [url, setUrl] = useState('')
  const navigate = useNavigate()

  const toLoginPage = () => navigate('/auth')

  const resetPage = () => setAsoAutenticado(undefined)

  const initialValues = {
    hash: code || '',
  }

  const relatorioSchema = Yup.object().shape({
    hash: Yup.string()
      .min(10, 'O campo código de autenticação deve possuir no mínimo 10 caracteres')
      .max(50, 'O campo código de autenticação deve possuir no máximo 50 caracteres')
      .required('Código de autenticação é obrigatório'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: relatorioSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const relatorio = await getAsoAutenticado(values.hash)
        if (relatorio !== undefined) {
          var a = document.createElement('a')
          a.href = toAbsoluteUrl(
            'data:application/pdf;base64,' +
              (relatorio !== undefined ? relatorio.contentBase64 : '')
          )
          setUrl(a.href)
          a.download = String(relatorio?.name)
        }
        setAsoAutenticado(relatorio)
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <>
      {asoAutenticado !== undefined ? (
        <>
          <object
            width='100%'
            height='500px'
            data={url + '#navpanes=0&scrollbar=0'}
            aria-label='Resultado da autenticacao em PDF'
          >
            Resultado da autenticacao em PDF
          </object>
          <div className='d-flex justify-content-end mt-3'>
            <Button type={ButtonType.Reset} className='btn-secondary' onClick={resetPage}>
              Nova Consulta
            </Button>
          </div>
        </>
      ) : (
        <form className='form' onSubmit={formik.handleSubmit}>
          <FormInput
            formik={formik}
            label='Código de autenticação'
            name='hash'
            placeholder='Digite o código de autenticação'
          />

          <div className='d-flex justify-content-center mt-3'>
            <Button type={ButtonType.Reset} className='btn-secondary me-3' onClick={toLoginPage}>
              {t('common.cancel')}
            </Button>
            <Button type={ButtonType.Submit} className='btn-primary'>
              {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
            </Button>
          </div>
        </form>
      )}
    </>
  )
}
